import React, { useContext, useEffect, useState } from 'react';

import FireDataContext from '../../../services/firebase/FireDataContext';
import AuthContext from '../../../services/firebase/AuthContext';
import MemberBookingCard from './MemberBookingCard';
import Grid from '@material-ui/core/Grid'

const BookingsGridView = ({ bookings }) => {

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item container direction="column" xs={12} lg={4}>
                    {
                        bookings.filter(b => !b.completed)
                            .map(booking => {
                                return <MemberBookingCard key={booking.id} booking={booking} />
                            })
                    }
                </Grid>
                <Grid item container direction="column" xs={12} lg={4}>
                    {
                        bookings.filter(b => b.completed)
                            .map(booking => {
                                return <MemberBookingCard key={booking.id} booking={booking} />
                            })
                    }
                </Grid>
            </Grid>
        </div>
    );
}

const BookingsColumnView = ({ bookings }) => {
    return (
        <div>
            {
                bookings
                    .map(booking => {
                        return <MemberBookingCard key={booking.id} booking={booking} />
                    })
            }
        </div>
    );

}

const MemberBookingList = ({ layout = 'column' }) => {
    const db = useContext(FireDataContext);
    const { currentUser: { uid } } = useContext(AuthContext);

    const [bookings, setBookings] = useState();

    useEffect(() => {
        const unsubscribe = db.subscribe({
            path: `intermediaries/${uid}/bookings`,
            hook: data => {
                setBookings(data.sort((a, b) => b.ts - a.ts));
            },
            context: 'MemberBookingList'
        });

        return unsubscribe;
    }, [db, uid])


    if (!bookings) return <></>;

    if (layout === 'grid') {
        return <BookingsGridView bookings={bookings} />
    }
    else {
        return <BookingsColumnView bookings={bookings} />
    }
};

export default MemberBookingList;